var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$isBuyer())?_c('confirm-dialog',{attrs:{"button-text":_vm.$t('buttons.buy'),"button-icon":"mdi-cart-outline","title":"Confirm purchase","text":"You will be redirected to the checkout page.","button-attrs":{
    class: 'px-5 ml-5',
    color: 'primary',
    loading: _vm.loading,
    disabled: _vm.isDisabled,
  }},on:{"confirm":_vm.checkCanBuy}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }